// extracted by mini-css-extract-plugin
export default {"container":"MDXContent_container__1Lk08","tocContainer":"MDXContent_tocContainer__De59j","proseRoot":"MDXContent_proseRoot__XCxLL"};